import React, { useState } from "react";
import { useCart } from "../../context/CartContext";
import styles from "./CartPage.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faPlus,
  faMinus,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import CartEnquiryModal from "../CartEnquiryModal";

const CartPage = () => {
  const { cart, removeFromCart, updateQuantity, clearCart } = useCart();
  const [showEnquiryCartModel, setShowEnquiryModal] = useState(false);
  const subtotal = cart.reduce((sum, i) => sum + i.ourPrice * i.quantity, 0);
  const totalSavings = cart.reduce(
    (sum, i) => sum + (i.price - i.ourPrice) * i.quantity,
    0
  );

  if (cart.length === 0) {
    return (
      <div className={styles.emptyCart}>
        <h2>Your Cart is Empty 🛒</h2>
        <p>Looks like you haven’t added anything yet.</p>
        <Link to="/gallery" className={styles.shopNowBtn}>
          Browse Products
        </Link>
      </div>
    );
  }

  return (
    <>
      <div className={styles.cartPage}>
        <h1 className={styles.pageTitle}>Your Shopping Cart</h1>

        <div className={styles.cartContent}>
          {/* Left: Cart Items */}
          <div className={styles.cartItems}>
            {cart.map((item) => (
              <div key={item._id} className={styles.cartItem}>
                {/* Product Image */}
                <div className={styles.imageWrapper}>
                  <img
                    src={item.picture?.[0]?.path}
                    alt={item.name}
                    className={styles.productImage}
                  />
                </div>

                {/* Product Info */}
                <div className={styles.productDetails}>
                  <h3 className={styles.productName}>{item.name}</h3>

                  <p className={styles.series}>
                    {/* @ts-ignore */}
                    {item?.series?.title}
                  </p>
                  <p className={styles.color}>Color: {item.color}</p>

                  {/* Price Section */}
                  <div className={styles.priceSection}>
                    {item.price > item.ourPrice && (
                      <span className={styles.originalPrice}>
                        ₹{item.price.toLocaleString()}
                      </span>
                    )}
                    <span className={styles.discountedPrice}>
                      ₹{item.ourPrice.toLocaleString()}
                    </span>
                    {item.price > item.ourPrice && (
                      <span className={styles.savings}>
                        You Save ₹
                        {(item.price - item.ourPrice).toLocaleString()}
                      </span>
                    )}
                  </div>

                  {/* Quantity Controls */}
                  <div className={styles.quantityControls}>
                    <button
                      onClick={() =>
                        updateQuantity(item._id, Math.max(1, item.quantity - 1))
                      }
                      className={styles.qtyBtn}
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </button>
                    <span className={styles.qtyValue}>{item.quantity}</span>
                    <button
                      onClick={() =>
                        updateQuantity(item._id, item.quantity + 1)
                      }
                      className={styles.qtyBtn}
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </button>
                  </div>
                </div>

                {/* Item Total & Remove */}
                <div className={styles.itemTotal}>
                  <p className={styles.itemPrice}>
                    ₹{(item.ourPrice * item.quantity).toLocaleString()}
                  </p>
                  <button
                    className={styles.removeBtn}
                    onClick={() => removeFromCart(item._id)}
                  >
                    <FontAwesomeIcon icon={faTrash} /> Remove
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Right: Order Summary */}
          <div className={styles.orderSummary}>
            <h2>Order Summary</h2>
            <div className={styles.summaryRow}>
              <span>Subtotal</span>
              <span>₹{subtotal.toLocaleString()}</span>
            </div>
            {totalSavings > 0 && (
              <div className={styles.summaryRow}>
                <span>You Saved</span>
                <span className={styles.savingsHighlight}>
                  ₹{totalSavings.toLocaleString()}
                </span>
              </div>
            )}
            <div className={styles.summaryRowTotal}>
              <span>Total</span>
              <span>₹{subtotal.toLocaleString()}</span>
            </div>

            <button
              className={styles.checkoutBtn}
              onClick={() => setShowEnquiryModal(true)}
            >
              Enquire Now <FontAwesomeIcon icon={faArrowRight} />
            </button>
            <button className={styles.clearBtn} onClick={clearCart}>
              Clear Cart
            </button>
          </div>
        </div>
      </div>
      <CartEnquiryModal
        show={showEnquiryCartModel}
        onHide={() => {
          setShowEnquiryModal(false);
        }}
      />
    </>
  );
};

export default CartPage;
